import React, { useState } from "react";
import DefaultInput from "../../components/form/DefaultInput";
import { Button } from "antd";
import api from "../../utils/axios";
import { toast } from "react-toastify";
import classes from "./index.module.css";
import { Link } from "react-router-dom";
import useLang from "../../hooks/useLang";

const PasswordRecoveryForm: React.FC = () => {
	const [email, setEmail] = useState("");
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState("");
	const [disabledButton, setDisabledButton] = useState<boolean>(false);
	const { strings } = useLang("passwordRecoveryForm");
	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setEmail(e.target.value);
	};

	const handleSubmit = async (event: any) => {
		event.preventDefault();
		setLoading(true);
		setError("");

		try {
			const response = await api.post("User/StartRecoveryProcess", {
				email,
			});
			toast.success(strings?.toastSuccess);
			setDisabledButton(true);
		} catch (error) {
			setError(strings?.error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className={classes.mainContainer}>
			<div className={classes.firstContainer}>
				<h2 className={classes.title}>{strings?.title}</h2>
				<form onSubmit={handleSubmit} className={classes.form}>
					<div>
						<DefaultInput
							value={email}
							onChange={handleChange}
							required
							label={strings?.emailLabel}
							className={classes.input}
							placeholder={strings?.emailPlaceholder}
						/>
					</div>
					<div className={classes.buttonsContainer}>
						<Button
							onClick={handleSubmit}
							disabled={loading || disabledButton}
							className={classes.button}
						>
							{strings?.recoverPassword}
						</Button>
						<Link to="/login">
							<Button className={classes.buttonLogin}>
								{strings?.login}
							</Button>
						</Link>
					</div>
					{error && <p>{error}</p>}
				</form>
			</div>
		</div>
	);
};

export default PasswordRecoveryForm;
